var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagnosticCarteFond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 172.8,
    height: 172.8,
    viewBox: "0 0 172.8 172.8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "BG",
    d: "M0.4 34.8V0.4H34.8M0.4 34.8V69.2M0.4 34.8H34.8M0.4 69.2V103.6M0.4 69.2H34.8M0.4 103.6V138M0.4 103.6H34.8M0.4 138V172.4H34.8M0.4 138H34.8M34.8 0.4V34.8M34.8 0.4H69.2M34.8 34.8V69.2M34.8 34.8H69.2M34.8 69.2V103.6M34.8 69.2H69.2M34.8 103.6V138M34.8 103.6H69.2M34.8 138V172.4M34.8 138H69.2M34.8 172.4H69.2M69.2 0.4V34.8M69.2 0.4H103.6M69.2 34.8V69.2M69.2 34.8H103.6M69.2 69.2V103.6M69.2 69.2H103.6M69.2 103.6V138M69.2 103.6H103.6M69.2 138V172.4M69.2 138H103.6M69.2 172.4H103.6M103.6 0.4V34.8M103.6 0.4H138M103.6 34.8V69.2M103.6 34.8H138M103.6 69.2V103.6M103.6 69.2H138M103.6 103.6V138M103.6 103.6H138M103.6 138V172.4M103.6 138H138M103.6 172.4H138M138 0.4V34.8M138 0.4H172.4V34.8M138 34.8V69.2M138 34.8H172.4M138 69.2V103.6M138 69.2H172.4M138 103.6V138M138 103.6H172.4M138 138V172.4M138 138H172.4M138 172.4H172.787M172.4 34.8V69.2M172.4 69.2V103.6M172.4 103.6V138M172.4 138V172.4",
    stroke: "url(#paint0_radial_0_4)",
    strokeWidth: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172.401 172.4) rotate(-135) scale(199.131 183.425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1925",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770202,
    stopColor: "#1A1925",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosticCarteFond);
export default __webpack_public_path__ + "static/media/diagnostic-carte-fond.ac6297e8447009f618aafbb956d02f28.svg";
export { ForwardRef as ReactComponent };